import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { ApiCommunityService } from '@services/api-community.service';
import { ApiLoyaltyPlanService } from '@services/api-loyalty-plans.service';
import { SharedService } from '@services/shared.service';
import { CommunityModel } from '@shared/models/CommunityModel';
import { CustomerModel } from '@shared/models/CustomerModel';
import { Country } from '@shared/models/Enums';
import { LoyaltyPlanModel } from '@shared/models/LoyaltyPlanModel';

@Component({
    selector: 'app-costa-rica-lobby',
    templateUrl: './costa-rica-lobby.component.html',
    styleUrls: ['./costa-rica-lobby.component.scss']
})

export class CostaRicaLobbyComponent implements OnInit {

    @Output() onChangeCountry: EventEmitter<Country> = new EventEmitter<Country>();

    user: CustomerModel;

    myCommunities: CommunityModel[] = []; 
    myLoyaltyPlans: LoyaltyPlanModel[] = [];

    loadedPlans: boolean = false;

    constructor(public sharedService: SharedService,
        private apiCommunityService: ApiCommunityService,
        private apiLoyaltyPlanService: ApiLoyaltyPlanService,
        private router: Router) {
    }

    ngOnInit(): void {

        const session = this.apiCommunityService.getSession();
        if (session && session.user) {

            this.user = session.user;
            this._getAllCommunitiesByCustomer();
            this._getAllPlansByCustomer();
        }
        
    }

    navigateToPage(page) {

        this.router.navigate([page]);
    }

    onDetailsOrJoin(community: CommunityModel) {

        let country = this.user.country;
        if(community.country != null) country = community.country;

        // View community details
        this.router.navigate(['/community-detail', community.id], { queryParams: { country: country } });
    }

    goToCommunities(){
        
        this.router.navigate(['/communities']);
    }

    goToLoyaltyPlans(){
        
        this.router.navigate(['/loyalty-plans']);
    }

    onGoToMyPlan(plan: LoyaltyPlanModel) {

        this.router.navigate(['/loyalty-plan-details', plan.id], { queryParams: { country: plan.country } });
    }

    validWeedCR(community: CommunityModel): boolean {

        return !(community.country == 1 && community.id == 13);
    }

    private _getAllCommunitiesByCustomer() {

        this.sharedService.setLoading(true);

        this.apiCommunityService.getAllCommunitiesByCustomer(this.user.id).then((results) => {

            this.myCommunities = results

            this.sharedService.setLoading(false);
        },
            (err) => {

                this.sharedService.setLoading(false);

                let errMsg = `Error al cargar información de las comunidades.`;
                
                // Desautorizado navigate to login
                if (err.status == 401 || err.message?.indexOf('caducado') >= 0) {

                    this.sharedService.showErrorAlert(null, 'Error al cargar la información solicitada').then(()=>{
                        this.router.navigate(['/market']);
                    });
                    return;
                }
                this.sharedService.showErrorAlert(null, errMsg);
            });
    }

    private _getAllPlansByCustomer() {

        this.sharedService.setLoading(true);

        this.apiLoyaltyPlanService.getAllLoyaltyPlansByCustomer(this.user.id).then((results) => {

            this.loadedPlans = true;

            this.myLoyaltyPlans = results.filter(
                x => x.customers.some(c => c.finishedAt == null) && x.showInApp && x.deletedAt == null && x.endDateAt > new Date() 
            );

            this.sharedService.setLoading(false);
        },
            (err) => {

                this.sharedService.setLoading(false);

                let errMsg = `Error al cargar información de los planes de lealtad.`;
                
                // Desautorizado navigate to login
                if (err.status == 401 || err.message?.indexOf('caducado') >= 0) {

                    this.sharedService.showErrorAlert(null, 'Error al cargar la información solicitada').then(()=>{
                        this.router.navigate(['/market']);
                    });
                    return;
                }
                this.sharedService.showErrorAlert(null, errMsg);
            });
    }

}
